import { render, staticRenderFns } from "./AccreditationsList.vue?vue&type=template&id=626467d2&scoped=true&"
import script from "./AccreditationsList.vue?vue&type=script&lang=js&"
export * from "./AccreditationsList.vue?vue&type=script&lang=js&"
import style0 from "./AccreditationsList.vue?vue&type=style&index=0&id=626467d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626467d2",
  null
  
)

export default component.exports